/* Nord nav draft, desktop: a short Seed-style menu next to the logo. Shop and Learn open one shared glass
   panel that morphs between them (x/width/height and caret on springs k 260 d 28, hover pill k 420 d 34);
   Proof Center is a plain link. One rAF loop that stops when everything has settled. */
(() => {
  const root = document.querySelector("[data-nm]");
  if (!root) return;
  const header = document.querySelector(".site-header");
  const panel = document.querySelector(".nm-panel");
  const box = panel.querySelector(".nm-box");
  const caret = panel.querySelector(".nm-caret");
  const hl = root.querySelector(".nm-hl");
  const pill = root.querySelector(".nm-pill");
  const trigs = [...root.querySelectorAll(".nm-trig")];
  const links = [...root.querySelectorAll(".nm-link")];
  const views = [...panel.querySelectorAll(".nm-c")];
  const desk = matchMedia("(min-width: 901px)");
  const still = matchMedia("(prefers-reduced-motion: reduce)");

  const spring = (k, d) => ({ v: 0, x: 0, t: 0, k, d, set(t, snap) { this.t = t; if (snap || still.matches) { this.x = t; this.v = 0; } } });
  const S = { x: spring(260, 28), w: spring(260, 28), h: spring(260, 28), cx: spring(260, 28), hx: spring(420, 34), hw: spring(420, 34) };

  let cur = -1, isOpen = false, closeT = 0, raf = 0, last = 0, hlOn = false;

  // "you are here": the Shopify layout drops aria-current, so mark the item whose panel links to this URL
  if (!root.querySelector("[aria-current]")) {
    const path = (a) => new URL(a.href, location.href).pathname.replace(/\/$/, "");
    const here = location.pathname.replace(/\/$/, "");
    const groups = [...trigs.map((t, i) => [t, views[i]]), ...links.map((l) => [l, null])];
    const hit = here && groups.find(([el, view]) => [el, ...(view ? view.querySelectorAll("a") : [])].some((a) => path(a) === here));
    if (hit) hit[0].setAttribute("aria-current", "page");
  }

  // panel coordinates are relative to the header (its positioning context); keep it inside the nav
  const geo = (i) => {
    const hr = header.getBoundingClientRect(), nr = root.closest(".nav").getBoundingClientRect();
    const tr = trigs[i].getBoundingClientRect();
    const w = views[i].offsetWidth, h = views[i].offsetHeight, mid = tr.left + tr.width / 2;
    const x = Math.min(Math.max(tr.left - 18, nr.left), nr.right - w) - hr.left;
    return { x, y: nr.bottom - hr.top + 12, w, h, cx: mid - hr.left - x - 6.5 };
  };
  const pillGeo = (el) => { const r = el.getBoundingClientRect(), p = pill.getBoundingClientRect(); return [r.left - p.left, r.width]; };

  function highlight(el) {
    const [x, w] = pillGeo(el);
    S.hx.set(x, !hlOn); S.hw.set(w, !hlOn);
    hlOn = true; hl.classList.add("on"); kick();
  }
  function unhighlight() { hlOn = false; hl.classList.remove("on"); }

  function show(i, dir) {
    views.forEach((v, j) => {
      if (j === i) {
        v.classList.add("snap");
        v.style.transform = dir ? `translateX(${-dir * 12}px)` : "none";
        v.offsetWidth; // commit the start position
        v.classList.remove("snap");
        v.style.transform = "";
        v.classList.add("on");
        v.removeAttribute("inert");
      } else if (v.classList.contains("on")) {
        v.style.transform = `translateX(${dir * 12}px)`;
        v.classList.remove("on");
        v.setAttribute("inert", "");
      }
    });
  }

  function open(i) {
    clearTimeout(closeT);
    highlight(trigs[i]);
    if (i === cur && isOpen) return;
    const g = geo(i), fresh = !isOpen;
    show(i, fresh || still.matches ? 0 : Math.sign(i - cur));
    S.x.set(g.x, fresh); S.w.set(g.w, fresh); S.h.set(g.h, fresh); S.cx.set(g.cx, fresh);
    panel.style.setProperty("--y", g.y + "px");
    trigs.forEach((t, j) => t.setAttribute("aria-expanded", j === i ? "true" : "false"));
    cur = i; isOpen = true;
    panel.classList.add("open");
    kick();
  }

  function close(now, keepHl) {
    clearTimeout(closeT);
    const run = () => {
      isOpen = false;
      panel.classList.remove("open");
      if (!keepHl) unhighlight();
      trigs.forEach((t) => t.setAttribute("aria-expanded", "false"));
    };
    now ? run() : (closeT = setTimeout(run, 150));
  }

  function frame(t) {
    const dt = Math.min(0.032, (t - (last || t)) / 1000 || 0.016);
    last = t;
    let moving = false;
    for (const s of Object.values(S)) {
      s.v += (-s.k * (s.x - s.t) - s.d * s.v) * dt; s.x += s.v * dt;
      if (Math.abs(s.v) < 0.02 && Math.abs(s.x - s.t) < 0.05) { s.x = s.t; s.v = 0; } else moving = true;
    }
    panel.style.setProperty("--x", S.x.x.toFixed(2) + "px");
    panel.style.setProperty("--ox", (S.cx.x + 6.5).toFixed(1) + "px");
    box.style.width = S.w.x.toFixed(2) + "px";
    box.style.height = S.h.x.toFixed(2) + "px";
    caret.style.setProperty("--cx", S.cx.x.toFixed(2) + "px");
    hl.style.transform = `translateX(${S.hx.x.toFixed(2)}px)`;
    hl.style.width = S.hw.x.toFixed(2) + "px";
    raf = moving ? requestAnimationFrame(frame) : 0;
    if (!raf) last = 0;
  }
  const kick = () => { if (!raf) raf = requestAnimationFrame(frame); };

  // mouse hovers open; a tap opens on the first touch and follows the link on the second
  let lastPointer = "mouse";
  addEventListener("pointerdown", (e) => { lastPointer = e.pointerType; }, true);
  trigs.forEach((t, i) => {
    t.addEventListener("pointerenter", (e) => { if (e.pointerType === "mouse" && desk.matches) open(i); });
    t.addEventListener("focus", () => { if (desk.matches && lastPointer !== "touch") open(i); });
    t.addEventListener("click", (e) => {
      if (lastPointer !== "mouse" && !(isOpen && cur === i)) { e.preventDefault(); open(i); }
    });
  });
  links.forEach((l) => {
    l.addEventListener("pointerenter", (e) => { if (e.pointerType === "mouse") { close(true, true); highlight(l); } });
    l.addEventListener("focus", () => { close(true, true); highlight(l); });
  });
  [root, panel].forEach((el) => {
    el.addEventListener("pointerenter", (e) => { if (e.pointerType === "mouse") clearTimeout(closeT); });
    el.addEventListener("pointerleave", (e) => { if (e.pointerType === "mouse") close(); });
  });
  addEventListener("keydown", (e) => { if (e.key === "Escape" && isOpen) { close(true); trigs[cur]?.focus(); } });
  document.addEventListener("pointerdown", (e) => {
    if (isOpen && !root.contains(e.target) && !panel.contains(e.target)) close(true);
  });
  root.addEventListener("focusout", (e) => { if (!root.contains(e.relatedTarget) && !panel.contains(e.relatedTarget)) close(); });
  panel.addEventListener("focusout", (e) => { if (!panel.contains(e.relatedTarget) && !root.contains(e.relatedTarget)) close(); });
  addEventListener("resize", () => { if (isOpen) { const g = geo(cur); for (const k in g) if (S[k]) S[k].set(g[k], true); panel.style.setProperty("--y", g.y + "px"); kick(); } });
  // the header slides away on scroll; close with it
  new MutationObserver(() => { if (header.classList.contains("hide")) close(true); }).observe(header, { attributes: true, attributeFilter: ["class"] });
})();

/* Mobile: Menu fills the screen with hydrogen water. A flat surface rises from the bottom on a soft spring,
   and each menu row floats up as the surface
   passes it. A tap sends a ring across the water. Closing drains it. One rAF loop, only while open. */
(() => {
  const M = document.querySelector(".nmf"), btn = document.querySelector(".menu-btn");
  if (!M || !btn) return;
  const cv = M.querySelector(".nmf-water"), ctx = cv.getContext("2d"), ui = M.querySelector(".nmf-ui");
  const top = M.querySelector(".nmf-top"), x = M.querySelector(".nmf-x");
  const mobile = matchMedia("(max-width: 900px)"), still = matchMedia("(prefers-reduced-motion: reduce)");
  const rows = [top, ...M.querySelectorAll(".nmf-prod, .nmf-learn .nmf-eye, .nmf-learn a, .nmf-proof, .nmf-small, .nmf-foot")];
  rows.forEach((r) => r.setAttribute("data-rv", ""));

  let drain = false, W = 0, H = 0, dpr = 1, open = false, raf = 0, last = 0, ys = [];
  const L = { x: 0, v: 0, t: 0 }; // surface level in px from the top
  let rings = [];

  function size() {
    dpr = Math.min(2, devicePixelRatio || 1); W = innerWidth; H = innerHeight;
    cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function show() {
    if (open) return;
    open = true; drain = false; M.hidden = false; M.classList.remove("draining");
    size();
    const nr = btn.closest(".nav").getBoundingClientRect();
    top.style.marginTop = nr.top + "px"; top.style.height = nr.height + "px"; top.style.padding = "0 8px 0 24px";
    ui.style.paddingLeft = ui.style.paddingRight = nr.left + "px";
    ui.scrollTop = 0;
    requestAnimationFrame(() => { ys = rows.map((r) => r.getBoundingClientRect().top + 14); });
    document.documentElement.classList.add("nav-lock");
    btn.setAttribute("aria-expanded", "true");
    if (still.matches) { L.x = L.t = -80; rows.forEach((r) => r.classList.add("in")); M.classList.add("open", "full"); draw(); return; }
    L.x = H + 40; L.v = 0; L.t = -170;
    requestAnimationFrame(() => M.classList.add("open"));
    setTimeout(() => open && M.classList.add("full"), 380);
    x.focus({ preventScroll: true });
    kick();
  }
  function hide() {
    if (!open) return;
    open = false;
    M.classList.remove("open", "full"); M.classList.add("draining");
    btn.setAttribute("aria-expanded", "false");
    document.documentElement.classList.remove("nav-lock");
    btn.focus({ preventScroll: true });
    if (still.matches) { rows.forEach((r) => r.classList.remove("in")); M.hidden = true; return; }
    L.t = H + 60; drain = true;
    kick();
  }

  function step(dt) {
    // level: soft spring, so the fill eases in and the drain falls away
    const k = drain ? 70 : 34, d = drain ? 15 : 10.5;
    L.v += (-k * (L.x - L.t) - d * L.v) * dt; L.x += L.v * dt;
    rings = rings.filter((r) => (r.t += dt) < 0.9);
    // rows float up as the surface passes them, and sink as it drains
    const s = L.x;
    rows.forEach((r, i) => {
      const y = ys[i] ?? 0;
      if (open && s < y && !r.classList.contains("in")) r.classList.add("in");
      else if (!open && s > y - 40 && r.classList.contains("in")) r.classList.remove("in");
    });
  }

  function draw() {
    ctx.clearRect(0, 0, W, H);
    const g = ctx.createLinearGradient(0, 0, 0, H);
    g.addColorStop(0, "#3a56cc"); g.addColorStop(0.38, "#1c2c72"); g.addColorStop(0.78, "#0a1030"); g.addColorStop(1, "#05070d");
    const y = Math.max(0, L.x);
    ctx.fillStyle = g; ctx.fillRect(0, y, W, H - y);
    if (L.x > -20 && L.x < H) { // the surface line, with a soft band of light under it
      const band = ctx.createLinearGradient(0, y, 0, y + 70);
      band.addColorStop(0, "rgba(207,220,255,.3)"); band.addColorStop(1, "rgba(207,220,255,0)");
      ctx.fillStyle = band; ctx.fillRect(0, y, W, 70);
      ctx.fillStyle = "rgba(225,234,255,.75)"; ctx.fillRect(0, L.x - 0.7, W, 1.4);
    }
    for (const r of rings) {
      ctx.globalAlpha = 0.5 * (1 - r.t / 0.9); ctx.beginPath(); ctx.arc(r.x, r.y, 8 + r.t * 70, 0, 6.2832);
      ctx.strokeStyle = "#cfdcff"; ctx.lineWidth = 1.2; ctx.stroke();
    }
    ctx.globalAlpha = 1;
  }

  function frame(t) {
    const dt = Math.min(0.033, (t - (last || t)) / 1000 || 0.016); last = t;
    step(dt); draw();
    const done = !open && L.x > H + 40 && !rings.length;
    if (done) { M.hidden = true; M.classList.remove("draining"); raf = 0; last = 0; return; }
    const settled = open && Math.abs(L.v) < 0.5 && Math.abs(L.x - L.t) < 0.5 && !rings.length; // full and still: stop drawing
    raf = document.hidden || settled ? 0 : requestAnimationFrame(frame);
    if (!raf) last = 0;
  }
  const kick = () => { if (!raf && !still.matches) raf = requestAnimationFrame(frame); };
  document.addEventListener("visibilitychange", () => { if (!document.hidden && !M.hidden) kick(); });

  // the stock mobile menu stays wired in main.js; take the click first on mobile
  document.addEventListener("click", (e) => {
    if (!mobile.matches || !e.target.closest(".menu-btn")) return;
    e.stopPropagation(); e.preventDefault();
    open ? hide() : show();
  }, true);
  x.addEventListener("click", hide);
  addEventListener("keydown", (e) => { if (e.key === "Escape" && open) hide(); });
  addEventListener("resize", () => { if (open) { size(); ys = rows.map((r) => r.getBoundingClientRect().top + 14); if (still.matches) draw(); } });
  mobile.addEventListener("change", () => { if (!mobile.matches && open) hide(); });

  // a ring spreads where a finger lands
  M.addEventListener("pointerdown", (e) => {
    if (!open) return;
    rings.push({ x: e.clientX, y: e.clientY, t: 0 });
    kick();
  });
  M.addEventListener("click", (e) => { if (e.target.closest("a")) setTimeout(hide, 120); });
})();
